import {
  POST,
  GET,
  GETPDF
} from '@/axios/axios'

export const services = {
  InterfaceRecheck: (param) => {   // 查重接口
    return GET('/backend/user/findByUserName', param)
  },
  ResetPassword: (param) => {    // 重置密码
    return GET('/backend/user/resetPassword', param);
  },
  RoleAuthorization: (param) => {   // 系统设置-角色授权
    return GET('/backend/role/findRoleByUserId', param)
  },
  RoleAll: (param) => {   // 系统设置-角色列表
    return GET('/backend/role/findRoles', param)
  },
  FacilitatorList: (param) => {  // 服务商列表
    return GET('/backend/custom/findServiceCustom', param)
  },
  ParentProjectMenu: (param) => {    // 菜单管理-父级项目
    return GET('/backend/user/findUserEntities', param)
  },
  AgentSetting: (param) => { // 系统设置-代理商设置列表
    return GET('/backend/dataDict/agentSetting', param);
  },
  MerchantSetting: (param) => { // 系统设置-商户设置列表
    return GET('/backend/dataDict/merchantSetting', param);
  },
  PersonalSetting: (param) => { // 系统设置-个人设置列表
    return GET('/backend/dataDict/personSetting', param);
  },
  SystemSetting: (param) => { // 系统设置-系统设置列表
    return GET('/backend/dataDict/systemSetting', param);
  },
  updateValue: (param) => { // 代理商设置提现时间保存
    return POST('/backend/dataDict/updateValue1', param);
  },
  SaveSettings: (param) => { // 系统设置保存
    return POST('/backend/dataDict/updateSetting', param);
  },
  UploadTemplate: (param) => { // OSS上传模版到字典
    return POST('/backend/upload/uploadFileTemplate', param);
  },
  PlatformSetting: (param) => { // 系统设置-平台设置列表
    return GET('/backend/custom/queryPlatformList', param);
  },
  SavePlatformSet: (param) => { // 平台设置保存
    return POST('/backend/custom/savePlatform', param);
  },
  LogRecord: (param) => { // 日志记录列表
    return GET('/backend/systemLogInfo/queryByPage', param);
  },
  OperationLogDoc: (param) => {   // 操作日志-操作记录
    return GET('/backend/operation/findOperationLogDoc', param);
  },
  exportQueryBy: (param) => {   // 下载中心列表
    return GET('/backend/exportExcel/queryByPage', param);
  },
  findUrlExport: (param) => {   // 下载中心-下载
    return GET('/backend/exportExcel/findUrlByExportExcelId', param);
  },
  deleteExport: (param) => {// 下载中心-删除
    return GET('/backend/exportExcel/deleteExportExcelById', param)
  },
  ExamineRoleId: (param) => {// 系统设置-角色设置-查看接口
    return GET('/backend/role/getRoleEntityByRoleId', param)
  },
  VolumeLicensees: (param) => {// 系统设置-角色设置-批量授权
    return POST('/backend/role/saveEntityForRole', param)
  },
  IndividualMandate: (param) => {// 系统设置-角色设置-单个授权
    return POST('/backend/role/saveEntityForRoleByOne', param)
  },
  CharacterSetup: (param) => {// 系统设置-角色设置-新增/编辑
    return POST('/backend/role/save', param)
  },
  CharacterState: (param) => {// 系统设置-角色设置-启用/停用
    return GET('/backend/role/disable', param)
  },
  OperateDisable: (param) => {// 系统设置-角色设置-批量启用/停用
    return GET('/backend/role/operateDisable', param)
  },
  DeleteRole: (param) => {// 系统设置-角色设置-删除
    return GET('/backend/role/deleteRole', param)
  },
  getCashUpdateCode: (param) => {// 系统设置-获取短信验证码
    return GET('/backend/sendMessage/getCashUpdateCode', param)
  },
  updateCashMobile: (param) => {// 系统设置-获取短信验证码
    return POST('/backend/dataDict/updateCashMobile', param)
  },
  serviceFeeList: (param) => {// 服务费明细
    return GET('/backend/serviceFee/serviceFeeList', param)
  },
  serviceFeeExport: (param, rsType) => { // 服务费明细导出
    return GETPDF("/backend/serviceFee/serviceFeeExport", param, rsType);
  },
  getCanCashService: (param) => {// 获取可提现服务费的接口
    return GET('/backend/account/getCanCashService', param);
  },
  queryServiceFee: (param) => {// 获取可提现服务费的接口
    return GET('/backend/account/queryServiceFeeAccountBalanceByService', param)
  },
  getSettingInfo: () => {// 获取手机号
    return GET('/backend/dataDict/getSettingInfo?key=CASH_OUT_ALI_SERVICE_FEE')
  },
  getCashCode: (param) => {// 获取短信验证码
    return GET('/backend/sendMessage/getCashCode', param)
  },
  createCash: (param) => {// 服务费提现
    return POST('/backend/serviceFee/createCash', param)
  },
  cashList: (param) => {// 提现列表
    return GET('/backend/serviceFee/cashList', param)
  },
  cashListExport: (param, rsType) => { // 服务费明细导出
    return GETPDF("/backend/serviceFee/cashListExport", param, rsType);
  },
  aliServiceList: (param) => {// 充值服务费
    return GET('/backend/serviceFee/getAliServiceList', param)
  },
  aliRefundList: (param) => {// 获取退款记录
    return GET('/backend/serviceFee/getAliRefundList', param)
  },
  aliPayToLlList: (param) => {// 支付宝转连连
    return GET('/backend/serviceFee/getAliPayToLlList', param)
  },
  applyServiceAut: (param) => {// 授权生成记账本
    return GET('/backend/account/backend/applyServiceAuthorization', param)
  },
  findServiceBookList: (param) => {// 服务费记账本 列表
    return GET('/backend/account/findServiceBookList', param)
  },
  serviceChargeAccount: (param) => {// 服务费明细（支付宝） 列表
    return GET('/backend/serviceChargeAccount/findServiceChargeAccount', param)
  },
  serviceChargeAccountExport: (param, rsType) => { // 服务费明细（支付宝）导出
    return GETPDF("/backend/serviceChargeAccount/findServiceChargeAccountExport", param, rsType);
  }
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/systemSettings.js